import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Card, Form, Input, InputNumber, Popconfirm, Switch } from 'antd';
import api from '../../api';
import helpers from '../../helpers'
import LoadingSpinner from '../../components/loading-spinner/loading-spinner';
import FaIcon from '../../components/global/fa-icon/fa-icon';



class NewsEditView extends Component {

  constructor(props) {
    super(props);

    this.movieHelper = helpers.movie;

    let id = _.get(this, 'props.match.params.id', null);

    this.state = {
      loaded: false,
      saving: false,
      id: id,
      data: null,
    };

    this.onArchivedSwitchChanged = this.onArchivedSwitchChanged.bind(this);
    this.onSortIndexChanged = this.onSortIndexChanged.bind(this);
    this.onMessageChanged = this.onMessageChanged.bind(this);
    this.onManagerNotesChanged = this.onManagerNotesChanged.bind(this);

    this.onSaveClicked = this.onSaveClicked.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
    this.onCancelClicked = this.onCancelClicked.bind(this);
    this.onDeleteClicked = this.onDeleteClicked.bind(this);

    setTimeout(() => {
      this.invalidateData();
    });
  }

  async invalidateData(forceUpdate = false) {
    let id = this.state.id;

    if (forceUpdate || !this.state.loaded) {
      this.prevQuery = null;
    }
    if (this.prevQuery && _.isEqual(this.prevQuery, id)) {
      return false;
    }
    this.prevQuery = id;

    let item = null;
    if (id) {
      let res = await api.news.get(id);
      item = _.get(res, 'data') || null;
    }
    if (!item) {
      item = new api.models.NewsModel();
    }

    this.setState({ loaded: true, data: item });
    return true;
  }

  _getTargetStringValue(e, trim = false) {
    let value = _.get(e, 'target.value');
    if (trim) {
      value = _.trim(value);
    }
    if (!value || _.isEmpty(value)) { value = null; }
    return value;
  }

  onArchivedSwitchChanged(value) {
    let data = this.state.data;
    data.archivedBooleanValue = !value;
    data.sortIndexIntValue = value? 0: null;
    this.setState({ data });
  }

  onSortIndexChanged(value) {
    let data = this.state.data;
    data.sortIndexIntValue = value;
    this.setState({ data });
  }

  onMessageChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.message = value;
    this.setState({ data });
  }

  onManagerNotesChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.manager_notes = value;
    this.setState({ data });
  }

  onSaveClicked(e) {
    // console.log('onSaveClicked', e);
    // console.log('model item', this.state.data);

    let modelData = this.state.data;
    this.setState({ loaded: false, saving: true }, () => {
      api.news.save(modelData.id, modelData).then(res => {
        // console.log('api.news saved', res);
        this.setState({ loaded: false, saving: false }, () => {
          // console.log('saved done');
          this.invalidateData(true);
        });
      });
    });
  }

  onBackClicked(e) {
    this.props.history.push('/news');
  }

  onCancelClicked(e) {
    this.onBackClicked();
  }

  onDeleteClicked() {
    let modelData = _.cloneDeep(this.state.data);
    this.setState({ loaded: false, saving: true }, () => {
      api.news.remove(modelData.id).then(res => {
        this.props.history.push('/news');
      });
    });
  }

  render() {

    let id = _.get(this, 'state.data.id') || _.get(this, 'state.id') || null;
    let canDelete = !!id;
    let title = id? ('Edit News ' + id): 'Add News';

    let titleActions = (
      <div className="title-actions">
        <Button type="default" size="large" icon={<FaIcon icon="fa-arrow-alt-left" />} onClick={this.onBackClicked}>Back</Button>
        <div className="title-text">{title}</div>
      </div>
    );

    let actions = (
      <div className="card-actions action-buttons">
        { canDelete? (
          <Popconfirm title="Are you sure you want to delete this news item?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={this.onDeleteClicked}>
            <Button type="danger" size="large" icon={<FaIcon icon="fa-trash" />}>Delete</Button>
          </Popconfirm>
        ) : null }
        <div className="ml-3">&nbsp;</div>
        <Button type="default" size="large" icon={<FaIcon icon="fa-times" />} onClick={this.onCancelClicked}>Cancel</Button>
        <Button type="primary" size="large" icon={<FaIcon icon="fa-check" />} onClick={this.onSaveClicked}>Save</Button>
      </div>
    );

    return (
      <div className="news-edit-view mx-auto" >
        <Card title={titleActions} extra={actions}>
          <div className="page-content">
            { (!this.state.loaded)? <LoadingSpinner />: null }

            { (this.state.loaded)? this.renderEditArea(): null }

            { (false && this.state.loaded)? this.renderJsonData(): null }
          </div>
        </Card>
      </div>
    );
  }

  renderEditArea() {
    let data = this.state.data;

    return (
      <Form className="edit-news-content d-flex flex-row" layout="vertical">
        <div className="details-area container-fluid">

          <div className="row">
            <div className="col-sm-12 col-12">
              <Form.Item label="Message" colon={false}>
                <Input.TextArea rows={6} value={data.message} onChange={this.onMessageChanged} />
              </Form.Item>
            </div>

            <div className="col-sm-3 col-12">
              <Form.Item label="Is Published"
                         help={data.archived? ('Archived on ' + this.movieHelper.formatLongDateValue(data.archivedMomentValue)): null}
                         colon={false}>
                <Switch checked={!data.archivedBooleanValue} onChange={this.onArchivedSwitchChanged} />
              </Form.Item>
            </div>

            <div className="col-sm-3 col-12">
              <Form.Item label="Sort Order" colon={false}>
                <InputNumber className="fillx" min={0} max={999} disabled={data.archivedBooleanValue} value={data.sortIndexIntValue} onChange={this.onSortIndexChanged} />
              </Form.Item>
            </div>

            <div className="col-sm-6 col-12">
              <Form.Item label="Optional Manager Notes" colon={false}>
                <Input.TextArea rows={3} value={data.manager_notes} onChange={this.onManagerNotesChanged} />
              </Form.Item>
            </div>
          </div>

        </div>
      </Form>
    );
  }

  renderJsonData() {
    return (
      <pre>{ JSON.stringify(this.state.data, null, 2) }</pre>
    );
  }

}



function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewsEditView));

